import { jsx as _jsx } from "react/jsx-runtime";
import { Button as AriaButton } from 'react-aria-components';
export function Button({ variant = 'secondary', size = 'md', className = '', children, ...props }) { return _jsx(AriaButton, { ...props, className: `ui-button ui-button--${variant} ui-button--${size} ${className}`, children: children }); }
//# sourceMappingURL=Button.js.map